import { Exception } from '@web/common';

export class UploadException extends Exception {
  public constructor(message: string) {
    super(message);
  }
}
